import vue from "vue";
import VueI18n from "vue-i18n";
vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "th",
  messages: {
    de: require("../lang/de"),
    th: require("../lang/th"),
    zh: require("../lang/zh"),
    ko: require("../lang/ko"),
  },
});
export { i18n };
